<template>
  <div class="background-small">
    <div class="f sb flex-start pb-4 px-3">
      <h4 class="text-white">
        Get <span class="free-text">Free</span> CS2 Skins
      </h4>
    </div>
    <div class=" pb-4 px-3">
      <span class="letter-spaced danger-text">{{ infoText }}</span>
    </div>
    <div class="wrapper px-3">
      <div v-if="itemLoading" class="collection_grid">
        <ShimmerEffect v-for="index in 1" :key="index" />
      </div>
      <div>
        <div v-if="!itemLoading" class="collection_grid_giveaway py-2">
          <GiveawayCard v-for="item in giveaways" :key="item.name" :item="item" :button-text="buttonText"
            :is-user-authenticated="isUserAuth" :is-button-disabled="isButtonDisabled"
            @join-giveaway="handleJoinGiveaway" @sign-in="handleSignIn" />
        </div>
      </div>
    </div>
    <div v-if="tasks.length > 0" class="tasks-section px-3 py-4">
      <div class="f sb">
        <h6 class="text-white mb-3">Tasks</h6>
        <h6 class="silver mb-3">{{ taskCount.completed }}/{{ tasks.length }} Tasks Remaining</h6>
      </div>

      <div class="task-list">
        <div v-for="task in tasks" :key="task.id" class="task-card f between align-center mb-2"
          :class="{ completed: task.completed }">
          <div class="f align-center gap-2">
            <img :src="task.icon" class="task-icon" />
            <span class="text-white f-15">{{ task.description }}</span>
          </div>
          <button class="task-button" :disabled="task.completed" @click="handleTask(task)">
            {{ task.completed ? 'Completed' : task.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <InfoModal v-if="showModal" :message="modalMessage" @close="showModal = false" />
</template>
<script>
/* eslint-disable */
import RareCard from "@/components/cards/RareCard.vue";
import GiveawayCard from "@/components/cards/GiveawayCard.vue";
import GiveawayService from "@/services/GiveawayService.js"
import ShimmerEffect from "@/components/skeleton/ShimmerItemCard.vue";
import SortDropdown from "../components/dropdownButtons/SortDropdown.vue";
import twitter from "@/assets/images/twitter-white.png";
import discord from "@/assets/images/discord-white.png";
import mail from "@/assets/images/mail.png";

import DateUtils from "@/utils/DateUtils.js";
import steamIcon from "../assets/images/steam-white.png";
import AuthService from "../services/AuthService.js";
import TaskService from "../services/TaskService.js";

export default {
  data() {
    return {
      showModal: false,
      isButtonDisabled: false,
      modalMessage: "",
      giveaways: [],
      totalPages: 10,
      loading: true,
      itemLoading: true,
      isDropdownOpen: false,
      steamIcon: steamIcon,
      taskCount: {
        completed: 0,
        inCompleted: 0
      },
      icons: {
        mail: mail,
        discord: discord,
        twitter: twitter
      },
      filterObject: {
        pageSize: 20,
        pageNumber: 1,
        orderDir: "DESC",
        orderBy: "date",
        market: "all",
      },
      infoText: "You can participate in giveaways by completing the required tasks.",
      pageTitle: "Get Free CS2 Skins",
      isUserAuth: false,
      tasks: []
    };
  },
  methods: {
    async handleTask(task) {

      switch (task.type) {
        case 'TWITTER_FOLLOW':
          window.open('https://x.com/steamanalyzer', '_blank');
          break;
        case 'MAIL_CONFIRM':
          this.$router.push({ path: '/user-details', hash: '#e_mail' });
          break;
        case 'DISCORD_JOIN':
          window.open('https://discord.com/invite/nfCfpE3d6V', '_blank');
          break;
        default:
          console.warn(`Unhandled task type: ${task.type}`);
      }

      await this.checkTaskCompletion(4000);

      const res = await TaskService.completeTask({ taskId: task.id });

      this.modalMessage = res.msg;
      this.showInfoModal();
      await this.getTasks();
      await this.getGiveaways();
    },
    async checkTaskCompletion(min) {
      return new Promise(resolve => setTimeout(() => resolve(true), min));
    },
    async getTasks() {
      const response = await TaskService.getUserTasks();
      if (!response) return this.tasks = [];
      this.tasks = response.map(task => {
        return {
          ...task,
          buttonText: task.completed ? 'Completed' : 'Complete',
          icon: this.icons[task.icon] || null,
        };
      });

      this.taskCount.completed = (this.tasks.filter(x => x.completed)).length;
    },
    async showInfoModal() {
      this.showModal = true;
      setTimeout(() => {
        this.showModal = false;
      }, 3000);
    },
    async setOrderDir(isAscOrder) {
      this.filterObject.orderDir = this.selectedDirection = isAscOrder
        ? "ASC"
        : "DESC";
      this.sortItems();
    },
    async setOrderBy(option) {
      this.filterObject.orderBy = option.toLowerCase();
      this.selectedOrder = option;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    async getGiveaways() {
      this.itemLoading = true;

      const response = this.isUserAuth ?
        await GiveawayService.getAllWithDetails({
          status: ""
        }) : await GiveawayService.getAll({
          status: ""
        });

      if (!response) return this.giveaways = [];
      this.giveaways = response;
      this.itemLoading = false;
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth < 1000;
    },
    async handleJoinGiveaway(id) {

      const response = await GiveawayService.join({
        giveaway_id: id
      });

      this.buttonText = response.success ? 'Joined' : 'Join Giveaway'
      this.modalMessage = response.msg;
      this.showInfoModal();
      this.getGiveaways()

    },
    async handleSignIn() {
      this.$router.push("/login");
    },
    async checkUser() {
      const response = await AuthService.authCheck();
      this.isUserAuth = response;
    },
  },
  async created() {
    await this.checkUser();
    await this.getGiveaways();
    this.getTasks()
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  computed: {
    DateUtils() {
      return DateUtils;
    },
    buttonText() {
      return this.isUserAuth ? "Join Giveaway" : "Sign In to Join";
    },
  },
  watch: {
    filterObject: {
      handler() {
        this.getGiveaways();
      },
      deep: true,
    },
  },
  components: {
    RareCard,
    ShimmerEffect,
    SortDropdown,
    GiveawayCard,
  },
};
</script>
<style scoped>
@import "../assets/style/customTable.css";

p {
  margin-bottom: 0;
}

.letter-spaced {
  letter-spacing: 0.5px;
  font-size: 14px;
}

.collection_grid_giveaway {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
}

.collection_grid {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  height: 400px;
  justify-content: center;
}

.free-text {
  font-size: 1.85rem;
  color: rgb(31, 255, 31);
  font-weight: bold;
}

.open_case {
  background-image: linear-gradient(to right,
      #25aae1,
      #40e495,
      #30dd8a,
      rgb(38, 133, 92));
  box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
  padding: 4px 8px;
  width: 140px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  cursor: pointer;
  margin-top: 5px;
  height: 40px;
  text-align: center;
  border: none;
  background-size: 300% 100%;
  border-radius: 4px;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.open_case:hover {
  transition: 0.3s;
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.task-list {
  grid-gap: .75rem;
  display: grid;
  gap: .75rem;
  grid-template-columns: repeat(2, 1fr);
}

.task-card {
  background-color: #0000003e;
  border-radius: 4px;
  padding: 1.4rem 1rem;
  border: 1px solid #2e2e3e8f;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.f-15 {
  font-size: 15px;
}

.task-icon {
  width: 24px;
  height: 24px;
}

.task-button {
  background-image: linear-gradient(to right,
      #954ce9 0%,
      #7d32d2 51%,
      #5b28f3 100%);
  background-size: 200% auto;
  background-position: left center;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  width: auto;
  transition: background-position 0.2s ease;
}

.task-card.completed .task-button {
  background-color: #16a34a;
  cursor: default;
}

.task-card.completed {
  opacity: 0.7;
}


@media screen and (max-width: 728px) {
  .task-list {
    grid-template-columns: repeat(1, 1fr);
  }

  .filter-div-mobile {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .mid-span {
    font-size: 16px;
  }

  p {
    font-size: 16px;
  }
}

h4 {
  margin-bottom: 0;
}
</style>
